export default "__VITE_ASSET__BL4s2_U0__"